
<style scoped>
.header {
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  padding-bottom: 20px;
  color: #832c75;
}
.list .item {
  display: flex;
  border-bottom: 1px solid #f8f8f8;
  line-height: 36px;
}
.list .item .left,
.list .item .right {
  flex: 1;
  display: flex;
}
.list .item .left .title,
.list .item .right .title {
  width: 120px;
  font-weight: bold;
}
.list .item .left .content,
.list .item .right .content {
  color: #666;
  flex: 1;
}
</style>
<template>
  <div class="list">
    <div class="item">
      <div class="left">
        <div class="title">所在学校:</div>
        <div class="content">{{ info.school_name }}</div>
      </div>
      <div class="right">
        <div class="title">测试日期:</div>
        <div class="content">{{ info.test_date }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">学校类别:</div>
        <div class="content">{{ info.school_category }}</div>
      </div>
      <div class="right">
         <div class="title">所在年级:</div>
        <div class="content">{{ info.grade }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">家长文化:</div>
        <div class="content">{{ info.parent_culture }}</div>
      </div>
      <div class="right">
        
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">沟通:</div>
        <div class="content">{{ info.score_communicate }}</div>
      </div>
      <div class="right">
        <div class="title">社区应用:</div>
        <div class="content">{{ info.score_community }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">学习功能:</div>
        <div class="content">{{ info.score_study }}</div>
      </div>
      <div class="right">
        <div class="title">居家生活:</div>
        <div class="content">{{ info.score_family }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">健康与安全:</div>
        <div class="content">{{ info.score_healthy }}</div>
      </div>
      <div class="right">
        <div class="title">休闲:</div>
        <div class="content">{{ info.score_leisure }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">自我照顾:</div>
        <div class="content">{{ info.score_self_care }}</div>
      </div>
      <div class="right">
        <div class="title">自我管理:</div>
        <div class="content">{{ info.score_self_guidance }}</div>
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">社交:</div>
        <div class="content">{{ info.score_social }}</div>
      </div>
      <div class="right">
        
      </div>
    </div>
    <div class="item">
      <div class="left">
        <div class="title">置信区间:</div>
        <div class="content">
          {{ info.confidence_probability }}
        </div>
      </div>
      <div class="right">
        <div class="title">显著性水平:</div>
        <div class="content">{{ info.significance_level }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object],
  },
  watch: {
    data: {
      handler: function (e) {
        this.info = e;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      info: null,
    };
  },
  created() {},
  methods: {},
};
</script>
